/* eslint-disable prefer-promise-reject-errors */
import L from 'leaflet';
import omnivore from '@mapbox/leaflet-omnivore';
import tj from 'togeojson';
import shp from 'shpjs';
import tokml from 'tokml';
import fileToArrayBuffer from 'file-to-array-buffer';
import kmzToKml from './KmzToKml';
import i18n from '@/main';

const fileTypes = ['wkt', 'kml', 'kmz', 'shp', 'zip'];

async function esperarLayers(layer) {
    // Cria um mapa invisível temporário
    const div = document.createElement('div');
    div.style.width = '1px';
    div.style.height = '1px';
    div.style.position = 'absolute';
    div.style.top = '-9999px';
    document.body.appendChild(div);

    const mapaTemporario = L.map(div);

    // Adiciona o layer ao mapa pra forçar o processamento
    layer.addTo(mapaTemporario);

    return new Promise((resolve, reject) => {
        const maxTentativas = 100;
        let tentativas = 0;

        const checar = () => {
            if (layer.getLayers && layer.getLayers().length > 0) {
                console.log('[LEITURA KML] Layers carregados!');
                mapaTemporario.remove();
                resolve();
            } else {
                tentativas++;
                if (tentativas >= maxTentativas) {
                    mapaTemporario.remove();
                    reject('Timeout esperando o KML carregar os layers');
                } else {
                    setTimeout(checar, 100);
                }
            }
        };

        checar();
    });
}

export default {
    async read(extension, content, rawFile) {
        const arquivoFormatoValido = fileTypes.includes(extension);

        if (!arquivoFormatoValido) {
            const errorMessage = i18n.t(
                'mensagens.comuns.upload.tipoDeArquivoNaoPermitido'
            );
            return Promise.reject(errorMessage);
        }

        let data = null;

        switch (extension) {
            case 'wkt':
                data = omnivore.wkt.parse(content);
                break;

            case 'kml': {
                const blob = new Blob([content], {
                    type: 'application/vnd.google-earth.kml+xml'
                });
                const url = URL.createObjectURL(blob);

                data = omnivore.kml(url);

                await new Promise((resolve, reject) => {
                    data.on('ready', () => {
                        resolve();
                    });

                    setTimeout(() => {
                        reject('Timeout esperando evento ready do KML');
                    }, 10000); // 10s timeout
                });

                break;
            }
            case 'kmz':
                let dadosKmz = null;
                await kmzToKml.parse(rawFile).then(kmlDom => {
                    dadosKmz = tj.kml(kmlDom);
                });

                const xKml = tokml(dadosKmz);
                data = omnivore.kml.parse(xKml);
                break;

            case 'zip':
                let arrayBuffer = null;

                await fileToArrayBuffer(rawFile).then(buffer => {
                    arrayBuffer = buffer;
                });
                const geojson = await shp(arrayBuffer);
                const kml = tokml(geojson);

                data = omnivore.kml.parse(kml);
                await esperarLayers(data);
                break;

            case 'shp':
                return Promise.reject(
                    'Faça o upload de um zip com os arquivos do shapefile'
                );
        }

        return new Promise((resolve, reject) => {
            resolve(data);
        });
    }
};
